import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, money } from '../api.js';

/**
 * Печатен изглед на ЗАПИСАН фиш за заплата — показва снимката такава,
 * каквато е била в момента на записа (виж payroll_payslips, миграция 118),
 * не наново изчислено. PDF-ът при „Изпрати по имейл" минава точно през
 * тази страница (services/pdf.js: renderPayslipPdf).
 */
export default function PrintPayslip() {
  const { id } = useParams();
  const [fish, setFish] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/api/payroll/payslips/${id}`)
      .then(setFish)
      .catch((e) => setError(e.message));
  }, [id]);

  if (error) return <div className="error">{error}</div>;
  if (!fish) return <div className="muted">Зареждане…</div>;

  const row = fish.snapshot;
  const [godina, mesec] = fish.period.split('-');
  const dniOtpusk = row.vacationDays ?? [];

  return (
    <div className="print-page">
      <div className="print-letterhead">
        <div>
          <img src="/brand/dp-logo.jpg" alt="Доктор Принтер" className="print-logo" />
        </div>
        <div className="print-contacts">
          <div>гр. Варна, ул. Батак 7</div>
          <div>тел. 052 989 334, 052 310 520, 0878 727 397</div>
        </div>
      </div>

      <div className="print-title">
        <h1>Фиш за заплата</h1>
        <div className="sub">{fish.employeeName} — {mesec}.{godina} г.</div>
      </div>

      <table className="print-lines">
        <tbody>
          <tr><td>Основна заплата</td><td className="num">{money(row.baseSalary)}</td></tr>
          <tr>
            <td>% от оборот „Стоки" ({row.percentGoods}% от {money(row.baseGoods ?? row.revenueGoods)})</td>
            <td className="num">{money(row.fromGoods)}</td>
          </tr>
          <tr>
            <td>% от оборот „Услуги" ({row.percentServices}% от {money(row.baseServices ?? row.revenueServices)})</td>
            <td className="num">{money(row.fromServices)}</td>
          </tr>
          <tr>
            <td>Заредени тонер касети ({row.refillCount} бр. × {money(row.tonerRate)})</td>
            <td className="num">{money(row.fromRefills)}</td>
          </tr>
          {row.bonuses.map((b) => (
            <tr key={`b${b.id}`}><td>Бонус — {b.label}</td><td className="num">{money(b.amount)}</td></tr>
          ))}
          {row.deductions.map((d) => (
            <tr key={`d${d.id}`}><td>Удръжка — {d.label}</td><td className="num">-{money(d.amount)}</td></tr>
          ))}
        </tbody>
      </table>

      {dniOtpusk.length > 0 && (
        <div className="muted" style={{ fontSize: '8pt', marginTop: '2mm' }}>
          Работни дни в отпуск през месеца: {dniOtpusk.length} — без процент от оборота за тях.
        </div>
      )}

      <div className="print-totals">
        <div>
          <span>Общо бонуси (% и зареждания)</span>
          <span>{money(row.fromGoods + row.fromServices + row.fromRefills)}</span>
        </div>
        <div>
          <span>
            Ваучери за храна (отделно, не са в сумата)
            {row.foodVoucherFull !== undefined && row.foodVoucherAmount !== row.foodVoucherFull
              && ` (${row.workedDays} от ${row.workingDays} работни дни)`}
          </span>
          <span>{money(row.foodVoucherAmount)}</span>
        </div>
        <div style={{ borderTop: '.3mm solid #333', marginTop: '1mm', paddingTop: '1mm', fontSize: '10.5pt' }}>
          <strong>Сума за вземане</strong>
          <strong>{money(row.total)}</strong>
        </div>
      </div>

      <div className="muted" style={{ fontSize: '7.5pt', marginTop: '4mm' }}>
        Записан на {new Date(fish.createdAt).toLocaleString('bg-BG')}
      </div>
    </div>
  );
}
